<div
  [title]="ratingValue + ' stars'"
  class="star-rating"
  [innerHTML]="starRatingSafeHTML"
></div>
